// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IPlateType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    canBePersonalized: boolean;
    canBeDisabled: boolean;
    canBeSmall: boolean;
    isCustomerManaged: boolean;
    sortOrder: number;
    active: boolean;
    isSpecializedPlate: boolean;
}

export class PlateType implements IPlateType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public canBePersonalized: boolean;
    public canBeDisabled: boolean;
    public canBeSmall: boolean;
    public isCustomerManaged: boolean;
    public sortOrder: number;
    public active: boolean;
    public isSpecializedPlate: boolean;

    /**
        Returns Standard PlateType
    **/
    get PassengerVehicle(): IPlateType {
        return this.FromId(1064);
    }
    /**
        Returns Disability Placard Permanent  PlateType
    **/
    get DisabilityPlacardPermanent(): IPlateType {
        return this.FromId(1028);
    }
    /**
        Returns Motorcycle PlateType
    **/
    get Motorcycle(): IPlateType {
        return this.FromId(1060);
    }
    /**
        Returns Commercial Vehicle  PlateType
    **/
    get CommercialVehicle(): IPlateType {
        return this.FromId(1025);
    }
    /**
        Returns Apportioned PlateType
    **/
    get Apportioned(): IPlateType {
        return this.FromId(1003);
    }
    /**
        Returns Trailer  PlateType
    **/
    get Trailer(): IPlateType {
        return this.FromId(1074);
    }
    /**
        Returns Trailer Small PlateType
    **/
    get TrailerSmall(): IPlateType {
        return this.FromId(1092);
    }
    /**
        Returns Arizona Cardinals PlateType
    **/
    get ArizonaCardinals(): IPlateType {
        return this.FromId(1005);
    }
    /**
        Returns Veteran  PlateType
    **/
    get Veteran(): IPlateType {
        return this.FromId(1079);
    }
    /**
        Returns Historic Vehicle  PlateType
    **/
    get HistoricVehicle(): IPlateType {
        return this.FromId(1047);
    }
    /**
        Returns ASU PlateType
    **/
    get CollegiateASU(): IPlateType {
        return this.FromId(1020);
    }
    /**
        Returns NAU PlateType
    **/
    get CollegiateNAU(): IPlateType {
        return this.FromId(1021);
    }
    /**
        Returns UofA PlateType
    **/
    get CollegiateUofA(): IPlateType {
        return this.FromId(1022);
    }
    /**
        Returns Moped PlateType
    **/
    get Moped(): IPlateType {
        return this.FromId(1059);
    }
    /**
        Returns Alternative Fuel PlateType
    **/
    get AlternativeFuel(): IPlateType {
        return this.FromId(1000);
    }
    /**
        Returns Alternative Fuel MC PlateType
    **/
    get AlternativeFuelMC(): IPlateType {
        return this.FromId(1136);
    }
    /**
        Returns Amateur Radio PlateType
    **/
    get AmateurRadio(): IPlateType {
        return this.FromId(1001);
    }
    /**
        Returns Antique Plate PlateType
    **/
    get AntiquePlate(): IPlateType {
        return this.FromId(1002);
    }
    /**
        Returns Arizona Agriculture PlateType
    **/
    get ArizonaAgriculture(): IPlateType {
        return this.FromId(1004);
    }
    /**
        Returns Arizona Centennial  PlateType
    **/
    get ArizonaCentennial(): IPlateType {
        return this.FromId(1006);
    }
    /**
        Returns Arizona Coyotes  PlateType
    **/
    get ArizonaCoyotes(): IPlateType {
        return this.FromId(1007);
    }
    /**
        Returns Arizona Diamondbacks  PlateType
    **/
    get ArizonaDiamondbacks(): IPlateType {
        return this.FromId(1008);
    }
    /**
        Returns Arizona Highways  PlateType
    **/
    get ArizonaHighways(): IPlateType {
        return this.FromId(1009);
    }
    /**
        Returns Arizona Historical Society  PlateType
    **/
    get ArizonaHistoricalSociety(): IPlateType {
        return this.FromId(1010);
    }
    /**
        Returns Phoenix Raceway PlateType
    **/
    get PhoenixRaceway(): IPlateType {
        return this.FromId(1011);
    }
    /**
        Returns Arizona Sportsmen for Wildlife Conservation   PlateType
    **/
    get ArizonaSportsmenWildlife(): IPlateType {
        return this.FromId(1012);
    }
    /**
        Returns Boy Scouts of Arizona  PlateType
    **/
    get BoyScoutsofArizona(): IPlateType {
        return this.FromId(1013);
    }
    /**
        Returns Channel 8 PBS   PlateType
    **/
    get Channel8PBS(): IPlateType {
        return this.FromId(1014);
    }
    /**
        Returns Character Education  PlateType
    **/
    get CharacterEducation(): IPlateType {
        return this.FromId(1015);
    }
    /**
        Returns Child Abuse Prevention  PlateType
    **/
    get ChildAbusePrevention(): IPlateType {
        return this.FromId(1016);
    }
    /**
        Returns Childhood Cancer Research  PlateType
    **/
    get ChildhoodCancerResearch(): IPlateType {
        return this.FromId(1017);
    }
    /**
        Returns Choose Life  PlateType
    **/
    get ChooseLife(): IPlateType {
        return this.FromId(1018);
    }
    /**
        Returns Classic Car   PlateType
    **/
    get ClassicCar(): IPlateType {
        return this.FromId(1019);
    }
    /**
        Returns Commercial Bus - Taxi  PlateType
    **/
    get CommercialBusTaxi(): IPlateType {
        return this.FromId(1023);
    }
    /**
        Returns Commercial Truck Tractor  PlateType
    **/
    get CommercialTruckTractor(): IPlateType {
        return this.FromId(1024);
    }
    /**
        Returns Congressional Medal of Honor  PlateType
    **/
    get CongressionalMedalofHonor(): IPlateType {
        return this.FromId(1026);
    }
    /**
        Returns Dealer Auto PlateType
    **/
    get Dealer(): IPlateType {
        return this.FromId(1027);
    }
    /**
        Returns Disability Placard Temporary  PlateType
    **/
    get DisabilityPlacardTemporary(): IPlateType {
        return this.FromId(1029);
    }
    /**
        Returns Energy Efficient  PlateType
    **/
    get EnergyEfficient(): IPlateType {
        return this.FromId(1030);
    }
    /**
        Returns Environmental  PlateType
    **/
    get Environmental(): IPlateType {
        return this.FromId(1031);
    }
    /**
        Returns All In For Arizona Schools PlateType
    **/
    get ExtraordinaryEducator(): IPlateType {
        return this.FromId(1032);
    }
    /**
        Returns Honoring Fallen Police Officers PlateType
    **/
    get FamiliesofFallenPolice(): IPlateType {
        return this.FromId(1033);
    }
    /**
        Returns Farm Vehicle  PlateType
    **/
    get FarmVehicle(): IPlateType {
        return this.FromId(1034);
    }
    /**
        Returns Firefighter  PlateType
    **/
    get Firefighter(): IPlateType {
        return this.FromId(1035);
    }
    /**
        Returns Firefighter Safety Training   PlateType
    **/
    get FirefighterSafety(): IPlateType {
        return this.FromId(1036);
    }
    /**
        Returns Former Prisoner Of War  PlateType
    **/
    get FormerPrisonerOfWar(): IPlateType {
        return this.FromId(1037);
    }
    /**
        Returns Fraternal Order of Police  PlateType
    **/
    get FraternalOrderofPolice(): IPlateType {
        return this.FromId(1038);
    }
    /**
        Returns Girl Scouts PlateType
    **/
    get GirlScout(): IPlateType {
        return this.FromId(1039);
    }
    /**
        Returns Gold Star Family  PlateType
    **/
    get GoldStarFamily(): IPlateType {
        return this.FromId(1040);
    }
    /**
        Returns Golden Rule  PlateType
    **/
    get GoldenRule(): IPlateType {
        return this.FromId(1041);
    }
    /**
        Returns Government Alternative Fuel  PlateType
    **/
    get GovernmentAlternativeFuel(): IPlateType {
        return this.FromId(1042);
    }
    /**
        Returns Government Energy Efficient  PlateType
    **/
    get GovernmentEnergyEfficient(): IPlateType {
        return this.FromId(1043);
    }
    /**
        Returns Government PlateType
    **/
    get Government(): IPlateType {
        return this.FromId(1044);
    }
    /**
        Returns Midwestern University PlateType
    **/
    get MidwesternUniversity(): IPlateType {
        return this.FromId(1045);
    }
    /**
        Returns Deaf / Hard of Hearing PlateType
    **/
    get HearingImpaired(): IPlateType {
        return this.FromId(1046);
    }
    /**
        Returns Honorary Foreign Consul  PlateType
    **/
    get HonoraryForeignConsul(): IPlateType {
        return this.FromId(1048);
    }
    /**
        Returns Horseless Carriage  PlateType
    **/
    get HorselessCarriage(): IPlateType {
        return this.FromId(1049);
    }
    /**
        Returns Hunger Relief   PlateType
    **/
    get HungerRelief(): IPlateType {
        return this.FromId(1050);
    }
    /**
        Returns In God We Trust   PlateType
    **/
    get InGodWeTrust(): IPlateType {
        return this.FromId(1051);
    }
    /**
        Returns Interstate Vehicle  PlateType
    **/
    get InterstateVehicle(): IPlateType {
        return this.FromId(1052);
    }
    /**
        Returns Keep Arizona Beautiful   PlateType
    **/
    get KeepArizonaBeautiful(): IPlateType {
        return this.FromId(1053);
    }
    /**
        Returns Legion of Valor  PlateType
    **/
    get LegionofValor(): IPlateType {
        return this.FromId(1054);
    }
    /**
        Returns Manufacturer Test  PlateType
    **/
    get ManufacturerTest(): IPlateType {
        return this.FromId(1055);
    }
    /**
        Returns Manufacturer Test Laden  PlateType
    **/
    get ManufacturerTestLaden(): IPlateType {
        return this.FromId(1056);
    }
    /**
        Returns Masonic Fraternity   PlateType
    **/
    get MasonicFraternity(): IPlateType {
        return this.FromId(1057);
    }
    /**
        Returns Military Support/Freedom  PlateType
    **/
    get MilitarySupportFreedom(): IPlateType {
        return this.FromId(1058);
    }
    /**
        Returns National Guard  PlateType
    **/
    get NationalGuard(): IPlateType {
        return this.FromId(1061);
    }
    /**
        Returns Navajo Nation   PlateType
    **/
    get NavajoNation(): IPlateType {
        return this.FromId(1062);
    }
    /**
        Returns Off-Road Vehicle  PlateType
    **/
    get OffRoadVehicle(): IPlateType {
        return this.FromId(1063);
    }
    /**
        Returns Pearl Harbor Survivor  PlateType
    **/
    get PearlHarborSurvivor(): IPlateType {
        return this.FromId(1065);
    }
    /**
        Returns Pet Friendly/Spay & Neuter   PlateType
    **/
    get PetFriendlySpayNeuter(): IPlateType {
        return this.FromId(1066);
    }
    /**
        Returns Phoenix Suns   PlateType
    **/
    get PhoenixSuns(): IPlateType {
        return this.FromId(1067);
    }
    /**
        Returns Pink Ribbon/Cancer Awareness   PlateType
    **/
    get PinkRibbon(): IPlateType {
        return this.FromId(1068);
    }
    /**
        Returns Purple Heart Medal  PlateType
    **/
    get PurpleHeartMedal(): IPlateType {
        return this.FromId(1069);
    }
    /**
        Returns San Carlos Apache Tribe   PlateType
    **/
    get SanCarlosApacheTribe(): IPlateType {
        return this.FromId(1070);
    }
    /**
        Returns Southwest PGA PlateType
    **/
    get SouthwestPGA(): IPlateType {
        return this.FromId(1071);
    }
    /**
        Returns Street Rod  PlateType
    **/
    get StreetRod(): IPlateType {
        return this.FromId(1072);
    }
    /**
        Returns Thunderbird School of Global Management   PlateType
    **/
    get ThunderbirdSchool(): IPlateType {
        return this.FromId(1073);
    }
    /**
        Returns Donate Life Arizona PlateType
    **/
    get DonateLifeArizona(): IPlateType {
        return this.FromId(1075);
    }
    /**
        Returns Transporter  PlateType
    **/
    get Transporter(): IPlateType {
        return this.FromId(1076);
    }
    /**
        Returns U.S. Marine Corps PlateType
    **/
    get USMarine(): IPlateType {
        return this.FromId(1077);
    }
    /**
        Returns University of Phoenix  PlateType
    **/
    get UniversityofPhoenix(): IPlateType {
        return this.FromId(1078);
    }
    /**
        Returns White Mountain Apache Tribe   PlateType
    **/
    get WhiteMountainApacheTribe(): IPlateType {
        return this.FromId(1080);
    }
    /**
        Returns Women Veterans   PlateType
    **/
    get WomenVeterans(): IPlateType {
        return this.FromId(1081);
    }
    /**
        Returns Grand Canyon University PlateType
    **/
    get GrandCanyonUniversity(): IPlateType {
        return this.FromId(1082);
    }
    /**
        Returns Route 66 PlateType
    **/
    get Route66(): IPlateType {
        return this.FromId(1083);
    }
    /**
        Returns Special Olympics Arizona PlateType
    **/
    get SpecialOlympicsArizona(): IPlateType {
        return this.FromId(1084);
    }
    /**
        Returns Dealer (Motorcycle) PlateType
    **/
    get DealerMC(): IPlateType {
        return this.FromId(1085);
    }
    /**
        Returns Gold Star Family (Motorcycle) PlateType
    **/
    get GoldStarFamilyMC(): IPlateType {
        return this.FromId(1086);
    }
    /**
        Returns Government (Motorcycle) PlateType
    **/
    get GovernmentMC(): IPlateType {
        return this.FromId(1087);
    }
    /**
        Returns Historic Vehicle (Motorcycle) PlateType
    **/
    get HistoricVehicleMC(): IPlateType {
        return this.FromId(1089);
    }
    /**
        Returns Military Support/Freedom (Motorcycle) PlateType
    **/
    get MilitarySupportFreedomMC(): IPlateType {
        return this.FromId(1090);
    }
    /**
        Returns Purple Heart Medal (Motorcycle) PlateType
    **/
    get PurpleHeartMedalMC(): IPlateType {
        return this.FromId(1091);
    }
    /**
        Returns U.S. Marine Corps (Motorcycle) PlateType
    **/
    get USMarineMC(): IPlateType {
        return this.FromId(1093);
    }
    /**
        Returns Veteran (Motorcycle) PlateType
    **/
    get VeteranMC(): IPlateType {
        return this.FromId(1094);
    }
    /**
        Returns First Responder PlateType
    **/
    get FirstResponder(): IPlateType {
        return this.FromId(1095);
    }
    /**
        Returns Dealer Trailer PlateType
    **/
    get DealerTrailer(): IPlateType {
        return this.FromId(1096);
    }
    /**
        Returns Route 66 (Motorcycle) PlateType
    **/
    get Route66MC(): IPlateType {
        return this.FromId(1097);
    }
    /**
        Returns Barrett-Jackson Auto Auction PlateType
    **/
    get BarrettJackson(): IPlateType {
        return this.FromId(1098);
    }
    /**
        Returns Luke Air Force Base PlateType
    **/
    get LukeAFB(): IPlateType {
        return this.FromId(1099);
    }
    /**
        Returns Luke Air Force Base (Motorcycle) PlateType
    **/
    get LukeAFBMC(): IPlateType {
        return this.FromId(1100);
    }
    /**
        Returns First Responder (Motorcycle) PlateType
    **/
    get FirstResponderMC(): IPlateType {
        return this.FromId(1101);
    }
    /**
        Returns Arizona Science Center PlateType
    **/
    get ArizonaScienceCenter(): IPlateType {
        return this.FromId(1102);
    }
    /**
        Returns Community Service  PlateType
    **/
    get CommunityService(): IPlateType {
        return this.FromId(1103);
    }
    /**
        Returns Women Veterans Army PlateType
    **/
    get WomenVeteransArmy(): IPlateType {
        return this.FromId(1104);
    }
    /**
        Returns Women Veterans Navy PlateType
    **/
    get WomenVeteransNavy(): IPlateType {
        return this.FromId(1105);
    }
    /**
        Returns Women Veterans Marine PlateType
    **/
    get WomenVeteransMarine(): IPlateType {
        return this.FromId(1106);
    }
    /**
        Returns Women Veterans Air Force PlateType
    **/
    get WomenVeteransAirForce(): IPlateType {
        return this.FromId(1107);
    }
    /**
        Returns Women Veterans Coast Guard PlateType
    **/
    get WomenVeteransCoastGuard(): IPlateType {
        return this.FromId(1108);
    }
    /**
        Returns Women Veterans Native American Code Talker PlateType
    **/
    get WomenVeteransNativeAmerCodeTalk(): IPlateType {
        return this.FromId(1109);
    }
    /**
        Returns Distinguished Flying Cross  PlateType
    **/
    get DistinguishedFlyingCross(): IPlateType {
        return this.FromId(1110);
    }
    /**
        Returns Share the Road  PlateType
    **/
    get ShareTheRoad(): IPlateType {
        return this.FromId(1111);
    }
    /**
        Returns Habitat for Humanity PlateType
    **/
    get HabitatforHumanity(): IPlateType {
        return this.FromId(1112);
    }
    /**
        Returns Veteran Army PlateType
    **/
    get VeteranArmy(): IPlateType {
        return this.FromId(1113);
    }
    /**
        Returns Veteran Navy PlateType
    **/
    get VeteranNavy(): IPlateType {
        return this.FromId(1114);
    }
    /**
        Returns Veteran Marine PlateType
    **/
    get VeteranMarine(): IPlateType {
        return this.FromId(1115);
    }
    /**
        Returns Veteran Air Force PlateType
    **/
    get VeteranAirForce(): IPlateType {
        return this.FromId(1116);
    }
    /**
        Returns Veteran Coast Guard PlateType
    **/
    get VeteranCoastGuard(): IPlateType {
        return this.FromId(1117);
    }
    /**
        Returns Veteran Code Talker PlateType
    **/
    get VeteranNativeAmerCodeTalk(): IPlateType {
        return this.FromId(1118);
    }
    /**
        Returns Habitat For Humanity PlateType
    **/
    get HomeOwnership(): IPlateType {
        return this.FromId(1119);
    }
    /**
        Returns Alzheimers Awareness PlateType
    **/
    get AlzheimersAwareness(): IPlateType {
        return this.FromId(1120);
    }
    /**
        Returns Fiesta Bowl PlateType
    **/
    get FiestaBowl(): IPlateType {
        return this.FromId(1121);
    }
    /**
        Returns Veteran Army (Motorcycle) PlateType
    **/
    get VeteranArmyMC(): IPlateType {
        return this.FromId(1122);
    }
    /**
        Returns Veteran Navy (Motorcycle) PlateType
    **/
    get VeteranNavyMC(): IPlateType {
        return this.FromId(1123);
    }
    /**
        Returns Veteran Marine (Motorcycle) PlateType
    **/
    get VeteranMarineMC(): IPlateType {
        return this.FromId(1124);
    }
    /**
        Returns Veteran Air Force (Motorcycle) PlateType
    **/
    get VeteranAirForceMC(): IPlateType {
        return this.FromId(1125);
    }
    /**
        Returns Veteran Coast Guard (Motorcycle) PlateType
    **/
    get VeteranCoastGuardMC(): IPlateType {
        return this.FromId(1126);
    }
    /**
        Returns Veteran Code Talker (Motorcycle) PlateType
    **/
    get VeteranNativeAmerCodeTalkMC(): IPlateType {
        return this.FromId(1127);
    }
    /**
        Returns Women Veterans (Motorcycle) PlateType
    **/
    get WomenVeteransMC(): IPlateType {
        return this.FromId(1128);
    }
    /**
        Returns Women Veterans Army (Motorcycle) PlateType
    **/
    get WomenVeteransArmyMC(): IPlateType {
        return this.FromId(1129);
    }
    /**
        Returns Women Veterans Navy (Motorcycle) PlateType
    **/
    get WomenVeteransNavyMC(): IPlateType {
        return this.FromId(1130);
    }
    /**
        Returns Women Veterans Marine (Motorcycle) PlateType
    **/
    get WomenVeteransMarineMC(): IPlateType {
        return this.FromId(1131);
    }
    /**
        Returns Women Veterans Air Force (Motorcycle) PlateType
    **/
    get WomenVeteransAirForceMC(): IPlateType {
        return this.FromId(1132);
    }
    /**
        Returns Women Veterans Coast Guard (Motorcycle) PlateType
    **/
    get WomenVeteransCoastGuardMC(): IPlateType {
        return this.FromId(1133);
    }
    /**
        Returns Women Veterans Native American Code Talker (Motorcycle) PlateType
    **/
    get WomenVeteransNativeAmerCodeTalkMC(): IPlateType {
        return this.FromId(1134);
    }
    /**
        Returns Distinguished Flying Cross (Motorcycle) PlateType
    **/
    get DistinguishedFlyingCrossMC(): IPlateType {
        return this.FromId(1135);
    }
    /**
        Returns Arizona Rodeo PlateType
    **/
    get ArizonaRodeo(): IPlateType {
        return this.FromId(1137);
    }
    /**
        Returns Arizona Rodeo (Motorcycle) PlateType
    **/
    get ArizonaRodeoMotorcycle(): IPlateType {
        return this.FromId(1138);
    }
    /**
        Returns Congenital Heart Defect Awareness PlateType
    **/
    get CongenitalHeartDefectAwareness(): IPlateType {
        return this.FromId(1139);
    }
    /**
        Returns Congenital Heart Defect Awareness Motorcycle PlateType
    **/
    get CongenitalHeartDefectAwarenessMotorcycle(): IPlateType {
        return this.FromId(1140);
    }
    /**
        Returns Veterans of Foreign Wars PlateType
    **/
    get VeteransofForeignWars(): IPlateType {
        return this.FromId(1141);
    }
    /**
        Returns Veterans of Foreign Wars (Motorcycle) PlateType
    **/
    get VeteransofForeignWarsMotorcycle(): IPlateType {
        return this.FromId(1142);
    }
    /**
        Returns Make-A-Wish Arizona PlateType
    **/
    get MakeAWishArizona(): IPlateType {
        return this.FromId(1143);
    }
    /**
        Returns Make-A-Wish Arizona (Motorcycle) PlateType
    **/
    get MakeAWishArizonaMotorcycle(): IPlateType {
        return this.FromId(1144);
    }
    /**
        Returns Veterans of Foreign Wars Auxiliary Arizona PlateType
    **/
    get VeteransofForeignWarsAuxiliary(): IPlateType {
        return this.FromId(1145);
    }
    /**
        Returns Veterans of Foreign Wars Auxiliary Arizona (Motorcycle) PlateType
    **/
    get VeteransofForeignWarsAuxiliaryMotorcycle(): IPlateType {
        return this.FromId(1146);
    }
    /**
        Returns Children and Families PlateType
    **/
    get ChildrenAndFamilies(): IPlateType {
        return this.FromId(1147);
    }
    /**
        Returns Children and Families Motorcycle PlateType
    **/
    get ChildrenAndFamiliesMotorcycle(): IPlateType {
        return this.FromId(1148);
    }
    /**
        Returns Arizona Education PlateType
    **/
    get EducationCommunityEnrichment(): IPlateType {
        return this.FromId(1149);
    }
    /**
        Returns Arizona Education (Motorcycle) PlateType
    **/
    get EducationCommunityEnrichmentMC(): IPlateType {
        return this.FromId(1150);
    }
    /**
        Returns EMPOWER PlateType
    **/
    get EmpoweringCharitableOrganizations(): IPlateType {
        return this.FromId(1151);
    }
    /**
        Returns EMPOWER (Motorcycle) PlateType
    **/
    get EmpoweringCharitableOrganizationsMotorcycle(): IPlateType {
        return this.FromId(1152);
    }
    /**
        Returns Alice Cooper’s Solid Rock PlateType
    **/
    get EmpoweringTodaysYouth(): IPlateType {
        return this.FromId(1153);
    }
    /**
        Returns Alice Cooper’s Solid Rock (Motorcycle) PlateType
    **/
    get EmpoweringTodaysYouthMotorcycle(): IPlateType {
        return this.FromId(1154);
    }
    /**
        Returns Arizona Realtors Homes for All PlateType
    **/
    get RealEstateProfessional(): IPlateType {
        return this.FromId(1155);
    }
    /**
        Returns Arizona Realtors Homes for All (Motorcycle) PlateType
    **/
    get RealEstateProfessionalMotorcycle(): IPlateType {
        return this.FromId(1156);
    }
    /**
        Returns Cancer Support for Families PlateType
    **/
    get SupportCancerVictims(): IPlateType {
        return this.FromId(1157);
    }
    /**
        Returns Cancer Support for Families (Motorcycle) PlateType
    **/
    get SupportCancerVictimsMotorcycle(): IPlateType {
        return this.FromId(1158);
    }
    /**
        Returns Arizona 4-H PlateType
    **/
    get Arizona4H(): IPlateType {
        return this.FromId(1159);
    }
    /**
        Returns Arizona 4-H (Motorcycle) PlateType
    **/
    get Arizona4HMotorcycle(): IPlateType {
        return this.FromId(1160);
    }
    /**
        Returns Thunderbirds Charities PlateType
    **/
    get ThunderbirdCharities(): IPlateType {
        return this.FromId(1161);
    }
    /**
        Returns Thunderbirds Charities (Motorcycle) PlateType
    **/
    get ThunderbirdCharitiesMotorcycle(): IPlateType {
        return this.FromId(1162);
    }
    /**
        Returns Deaf / Hard of Hearing (Motorcycle) PlateType
    **/
    get DeafHardOfHearingMC(): IPlateType {
        return this.FromId(1163);
    }
    /**
        Returns Diné College Warriors PlateType
    **/
    get DineCollegeWarriors(): IPlateType {
        return this.FromId(1164);
    }
    /**
        Returns Diné College Warriors (Motorcycle) PlateType
    **/
    get DineCollegeWarriorsMotorcycle(): IPlateType {
        return this.FromId(1165);
    }
    /**
        Returns U.S. Army PlateType
    **/
    get USArmy(): IPlateType {
        return this.FromId(1166);
    }
    /**
        Returns U.S. Army (Motorcycle) PlateType
    **/
    get USArmyMotorcycle(): IPlateType {
        return this.FromId(1167);
    }
    /**
        Returns Arizona Coyotes (Motorcycle) PlateType
    **/
    get ArizonaCoyotesMotorcycle(): IPlateType {
        return this.FromId(1168);
    }
    /**
        Returns Honoring Fallen Police Officers (Motorcycle) PlateType
    **/
    get HonoringFallenPoliceOfficersMotorcycle(): IPlateType {
        return this.FromId(1169);
    }
    /**
        Returns State Forty Eight PlateType
    **/
    get StateFortyEight(): IPlateType {
        return this.FromId(1170);
    }
    /**
        Returns State Forty Eight (Motorcycle) PlateType
    **/
    get StateFortyEightMotorcycle(): IPlateType {
        return this.FromId(1171);
    }
    /**
        Returns In Loving Memory PlateType
    **/
    get InLovingMemory(): IPlateType {
        return this.FromId(1172);
    }
    /**
        Returns In Loving Memory (Motorcycle) PlateType
    **/
    get InLovingMemoryMotorcycle(): IPlateType {
        return this.FromId(1173);
    }
    /**
        Returns Keep Arizona Beautiful (Motorcycle) PlateType
    **/
    get KeepArizonaBeautifulMotorcycle(): IPlateType {
        return this.FromId(1174);
    }
    /**
        Returns Arizona Diamondbacks (Motorcycle) PlateType
    **/
    get ArizonaDiamondbacksMotorcycle(): IPlateType {
        return this.FromId(1175);
    }
    /**
        Returns National Guard (Motorcycle) PlateType
    **/
    get NationalGuardMotorcycle(): IPlateType {
        return this.FromId(1176);
    }
    /**
        Returns Arizona Highways (Motorcycle) PlateType
    **/
    get ArizonaHighwaysMotorcycle(): IPlateType {
        return this.FromId(1177);
    }
    /**
        Returns Hualapai Tribe PlateType
    **/
    get HualapaiTribe(): IPlateType {
        return this.FromId(1178);
    }
    /**
        Returns Hualapai Tribe (Motorcycle) PlateType
    **/
    get HualapaiTribeMotorcycle(): IPlateType {
        return this.FromId(1179);
    }
    /**
        Returns Rotary International PlateType
    **/
    get RotaryInternational(): IPlateType {
        return this.FromId(1180);
    }
    /**
        Returns Rotary International (Motorcycle) PlateType
    **/
    get RotaryInternationalMotorcycle(): IPlateType {
        return this.FromId(1181);
    }
    /**
        Returns Phoenix Rising FC PlateType
    **/
    get PhoenixRisingFC(): IPlateType {
        return this.FromId(1182);
    }
    /**
        Returns Phoenix Rising FC (Motorcycle) PlateType
    **/
    get PhoenixRisingFCMotorcycle(): IPlateType {
        return this.FromId(1183);
    }

    get AutismSupport(): IPlateType {
        return this.FromId(1184);
    }
    get AutismSupportMotorcycle(): IPlateType {
        return this.FromId(1185);
    }
    /**
        Returns Ovarian Cancer Awareness PlateType
    **/
    get OvarianCancerAwareness(): IPlateType {
        return this.FromId(1186);
    }
    /**
        Returns Ovarian Cancer Awareness (Motorcycle) PlateType
    **/
    get OvarianCancerAwarenessMotorcycle(): IPlateType {
        return this.FromId(1187);
    }
    /**
        Returns Verde Valley Wine Trail PlateType
    **/
    get VerdeValleyWineTrail(): IPlateType {
        return this.FromId(1188);
    }
    /**
        Returns Verde Valley Wine Trail (Motorcycle) PlateType
    **/
    get VerdeValleyWineTrailMotorcycle(): IPlateType {
        return this.FromId(1189);
    }
    /**
        Returns Phoenix Mercury PlateType
    **/
    get PhoenixMercury(): IPlateType {
        return this.FromId(1190);
    }
    /**
        Returns Phoenix Mercury (Motorcycle) PlateType
    **/
    get PhoenixMercuryMotorcycle(): IPlateType {
        return this.FromId(1191);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1064', { id: 1064, value: 'PassengerVehicle', displayValue: 'Standard', description: 'Standard Issue plate', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 5, active: true, isSpecializedPlate: false });
        this._dictionary.add('1028', { id: 1028, value: 'DisabilityPlacardPermanent', displayValue: 'Disability Placard Permanent ', description: 'Disability Placard Permanent ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: true, sortOrder: 10, active: true, isSpecializedPlate: false });
        this._dictionary.add('1060', { id: 1060, value: 'Motorcycle', displayValue: 'Motorcycle', description: 'Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 15, active: true, isSpecializedPlate: false });
        this._dictionary.add('1025', { id: 1025, value: 'CommercialVehicle', displayValue: 'Commercial Vehicle ', description: 'Commercial Vehicle ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 20, active: true, isSpecializedPlate: false });
        this._dictionary.add('1003', { id: 1003, value: 'Apportioned', displayValue: 'Apportioned', description: 'Apportioned', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: true, sortOrder: 25, active: true, isSpecializedPlate: false });
        this._dictionary.add('1074', { id: 1074, value: 'Trailer', displayValue: 'Trailer ', description: 'Trailer', canBePersonalized: true, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 30, active: true, isSpecializedPlate: false });
        this._dictionary.add('1092', { id: 1092, value: 'TrailerSmall', displayValue: 'Trailer Small', description: 'Trailer Small', canBePersonalized: true, canBeDisabled: false, canBeSmall: true, isCustomerManaged: false, sortOrder: 32, active: true, isSpecializedPlate: false });
        this._dictionary.add('1005', { id: 1005, value: 'ArizonaCardinals', displayValue: 'Arizona Cardinals', description: 'Arizona Cardinals', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 35, active: true, isSpecializedPlate: true });
        this._dictionary.add('1079', { id: 1079, value: 'Veteran', displayValue: 'Veteran ', description: 'Veteran ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 40, active: true, isSpecializedPlate: true });
        this._dictionary.add('1047', { id: 1047, value: 'HistoricVehicle', displayValue: 'Historic Vehicle ', description: 'Historic Vehicle ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 45, active: true, isSpecializedPlate: true });
        this._dictionary.add('1020', { id: 1020, value: 'CollegiateASU', displayValue: 'ASU', description: 'ASU', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 50, active: true, isSpecializedPlate: true });
        this._dictionary.add('1021', { id: 1021, value: 'CollegiateNAU', displayValue: 'NAU', description: 'NAU', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 50, active: true, isSpecializedPlate: true });
        this._dictionary.add('1022', { id: 1022, value: 'CollegiateUofA', displayValue: 'UofA', description: 'UofA', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 50, active: true, isSpecializedPlate: true });
        this._dictionary.add('1059', { id: 1059, value: 'Moped', displayValue: 'Moped', description: 'Moped', canBePersonalized: false, canBeDisabled: false, canBeSmall: true, isCustomerManaged: false, sortOrder: 55, active: true, isSpecializedPlate: false });
        this._dictionary.add('1000', { id: 1000, value: 'AlternativeFuel', displayValue: 'Alternative Fuel', description: 'Alternative Fuel', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 60, active: true, isSpecializedPlate: false });
        this._dictionary.add('1136', { id: 1136, value: 'AlternativeFuelMC', displayValue: 'Alternative Fuel MC', description: 'Alternative Fuel MC', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 60, active: true, isSpecializedPlate: false });
        this._dictionary.add('1001', { id: 1001, value: 'AmateurRadio', displayValue: 'Amateur Radio', description: 'Amateur Radio', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1002', { id: 1002, value: 'AntiquePlate', displayValue: 'Antique Plate', description: 'Antique Plate', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1004', { id: 1004, value: 'ArizonaAgriculture', displayValue: 'Arizona Agriculture', description: 'Arizona Agriculture', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1006', { id: 1006, value: 'ArizonaCentennial', displayValue: 'Arizona Centennial ', description: 'Arizona Centennial ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1007', { id: 1007, value: 'ArizonaCoyotes', displayValue: 'Arizona Coyotes ', description: 'Arizona Coyotes ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1008', { id: 1008, value: 'ArizonaDiamondbacks', displayValue: 'Arizona Diamondbacks ', description: 'Arizona Diamondbacks ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1009', { id: 1009, value: 'ArizonaHighways', displayValue: 'Arizona Highways ', description: 'Arizona Highways ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1010', { id: 1010, value: 'ArizonaHistoricalSociety', displayValue: 'Arizona Historical Society ', description: 'Arizona Historical Society ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1011', { id: 1011, value: 'Phoenix Raceway', displayValue: 'Phoenix Raceway', description: 'Phoenix Raceway', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1012', { id: 1012, value: 'ArizonaSportsmenWildlife', displayValue: 'Arizona Sportsmen for Wildlife Conservation  ', description: 'Arizona Sportsmen for Wildlife Conservation  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1013', { id: 1013, value: 'BoyScoutsofArizona', displayValue: 'Boy Scouts of Arizona ', description: 'Boy Scouts of Arizona ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1014', { id: 1014, value: 'Channel8PBS', displayValue: 'Channel 8 PBS  ', description: 'Channel 8 PBS  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1015', { id: 1015, value: 'CharacterEducation', displayValue: 'Character Education ', description: 'Character Education ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1016', { id: 1016, value: 'ChildAbusePrevention', displayValue: 'Child Abuse Prevention ', description: 'Child Abuse Prevention ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1017', { id: 1017, value: 'ChildhoodCancerResearch', displayValue: 'Childhood Cancer Research ', description: 'Childhood Cancer Research ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1018', { id: 1018, value: 'ChooseLife', displayValue: 'Choose Life ', description: 'Choose Life ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1019', { id: 1019, value: 'ClassicCar', displayValue: 'Classic Car  ', description: 'Classic Car  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1023', { id: 1023, value: 'CommercialBus-Taxi', displayValue: 'Commercial Bus - Taxi ', description: 'Commercial Bus - Taxi ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: false });
        this._dictionary.add('1024', { id: 1024, value: 'CommercialTruckTractor', displayValue: 'Commercial Truck Tractor ', description: 'Commercial Truck Tractor ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: false });
        this._dictionary.add('1026', { id: 1026, value: 'CongressionalMedalofHonor', displayValue: 'Congressional Medal of Honor ', description: 'Congressional Medal of Honor ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1027', { id: 1027, value: 'Dealer', displayValue: 'Dealer Auto', description: 'Dealer Auto', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: true, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1029', { id: 1029, value: 'DisabilityPlacardTemporary', displayValue: 'Disability Placard Temporary ', description: 'Disability Placard Temporary ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: true, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1030', { id: 1030, value: 'EnergyEfficient', displayValue: 'Energy Efficient ', description: 'Energy Efficient ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1031', { id: 1031, value: 'Environmental', displayValue: 'Environmental ', description: 'Environmental ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1032', { id: 1032, value: 'ExtraordinaryEducator', displayValue: 'All In For Arizona Schools', description: 'All In For Arizona Schools', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1033', { id: 1033, value: 'FamiliesofFallenPolice', displayValue: 'Honoring Fallen Police Officers', description: 'Honoring Fallen Police Officers', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1034', { id: 1034, value: 'FarmVehicle', displayValue: 'Farm Vehicle ', description: 'Farm Vehicle ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1035', { id: 1035, value: 'Firefighter', displayValue: 'Firefighter ', description: 'Firefighter ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1036', { id: 1036, value: 'FirefighterSafety', displayValue: 'Firefighter Safety Training  ', description: 'Firefighter Safety Training  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1037', { id: 1037, value: 'FormerPrisonerOfWar', displayValue: 'Former Prisoner Of War ', description: 'Former Prisoner Of War ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1038', { id: 1038, value: 'FraternalOrderofPolice', displayValue: 'Fraternal Order of Police ', description: 'Fraternal Order of Police ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1039', { id: 1039, value: 'GirlScout', displayValue: 'Girl Scouts', description: 'Girl Scouts', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1040', { id: 1040, value: 'GoldStarFamily', displayValue: 'Gold Star Family ', description: 'Gold Star Family ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1041', { id: 1041, value: 'GoldenRule', displayValue: 'Golden Rule ', description: 'Golden Rule ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1042', { id: 1042, value: 'GovernmentAlternativeFuel', displayValue: 'Government Alternative Fuel ', description: 'Government Alternative Fuel ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1043', { id: 1043, value: 'GovernmentEnergyEfficient', displayValue: 'Government Energy Efficient ', description: 'Government Energy Efficient ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1044', { id: 1044, value: 'Government', displayValue: 'Government', description: 'Government', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1045', { id: 1045, value: 'MidwesternUniversity', displayValue: 'Midwestern University', description: 'Midwestern University', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1046', { id: 1046, value: 'HearingImpaired', displayValue: 'Deaf / Hard of Hearing', description: 'Deaf / Hard of Hearing', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1048', { id: 1048, value: 'HonoraryForeignConsul', displayValue: 'Honorary Foreign Consul ', description: 'Honorary Foreign Consul ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1049', { id: 1049, value: 'HorselessCarriage', displayValue: 'Horseless Carriage ', description: 'Horseless Carriage ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1050', { id: 1050, value: 'HungerRelief', displayValue: 'Hunger Relief  ', description: 'Hunger Relief  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1051', { id: 1051, value: 'InGodWeTrust', displayValue: 'In God We Trust  ', description: 'In God We Trust  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1052', { id: 1052, value: 'InterstateVehicle', displayValue: 'Interstate Vehicle ', description: 'Interstate Vehicle ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1053', { id: 1053, value: 'KeepArizonaBeautiful', displayValue: 'Keep Arizona Beautiful  ', description: 'Keep Arizona Beautiful  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1054', { id: 1054, value: 'LegionofValor', displayValue: 'Legion of Valor ', description: 'Legion of Valor ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1055', { id: 1055, value: 'ManufacturerTest', displayValue: 'Manufacturer Test ', description: 'Manufacturer Test ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: true, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1056', { id: 1056, value: 'ManufacturerTestLaden', displayValue: 'Manufacturer Test Laden ', description: 'Manufacturer Test Laden ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: true, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1057', { id: 1057, value: 'MasonicFraternity', displayValue: 'Masonic Fraternity  ', description: 'Masonic Fraternity  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1058', { id: 1058, value: 'MilitarySupportFreedom', displayValue: 'Military Support/Freedom ', description: 'Military Support/Freedom ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1061', { id: 1061, value: 'NationalGuard', displayValue: 'National Guard ', description: 'National Guard ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1062', { id: 1062, value: 'NavajoNation', displayValue: 'Navajo Nation  ', description: 'Navajo Nation  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1063', { id: 1063, value: 'OffRoadVehicle', displayValue: 'Off-Road Vehicle ', description: 'Off-Road Vehicle ', canBePersonalized: false, canBeDisabled: false, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1065', { id: 1065, value: 'PearlHarborSurvivor', displayValue: 'Pearl Harbor Survivor ', description: 'Pearl Harbor Survivor ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1066', { id: 1066, value: 'PetFriendlySpayNeuter', displayValue: 'Pet Friendly/Spay & Neuter  ', description: 'Pet Friendly/Spay & Neuter  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1067', { id: 1067, value: 'PhoenixSuns', displayValue: 'Phoenix Suns  ', description: 'Phoenix Suns  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1068', { id: 1068, value: 'PinkRibbon', displayValue: 'Pink Ribbon/Cancer Awareness  ', description: 'Pink Ribbon/Cancer Awareness  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1069', { id: 1069, value: 'PurpleHeartMedal', displayValue: 'Purple Heart Medal ', description: 'Purple Heart Medal ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1070', { id: 1070, value: 'SanCarlosApacheTribe', displayValue: 'San Carlos Apache Tribe  ', description: 'San Carlos Apache Tribe  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1071', { id: 1071, value: 'SouthwestPGA', displayValue: 'Southwest PGA', description: 'Southwest PGA', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1072', { id: 1072, value: 'StreetRod', displayValue: 'Street Rod ', description: 'Street Rod ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1073', { id: 1073, value: 'ThunderbirdSchool', displayValue: 'Thunderbird School of Global Management  ', description: 'Thunderbird School of Global Management  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1075', { id: 1075, value: 'DonateLifeArizona', displayValue: 'Donate Life Arizona', description: 'Donate Life Arizona', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1076', { id: 1076, value: 'Transporter', displayValue: 'Transporter ', description: 'Transporter ', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: true, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1077', { id: 1077, value: 'U.S.Marine', displayValue: 'U.S. Marine Corps', description: 'U.S. Marine Corps', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1078', { id: 1078, value: 'UniversityofPhoenix', displayValue: 'University of Phoenix ', description: 'University of Phoenix ', canBePersonalized: false, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1080', { id: 1080, value: 'WhiteMountainApacheTribe', displayValue: 'White Mountain Apache Tribe  ', description: 'White Mountain Apache Tribe  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1081', { id: 1081, value: 'WomenVeterans', displayValue: 'Women Veterans  ', description: 'Women Veterans  ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1082', { id: 1082, value: 'GrandCanyonUniversity', displayValue: 'Grand Canyon University', description: 'Grand Canyon University', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1083', { id: 1083, value: 'Route66', displayValue: 'Route 66', description: 'Route 66', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1084', { id: 1084, value: 'SpecialOlympicsArizona', displayValue: 'Special Olympics Arizona', description: 'Special Olympics Arizona', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1085', { id: 1085, value: 'DealerMC', displayValue: 'Dealer (Motorcycle)', description: 'Dealer (Motorcycle)', canBePersonalized: false, canBeDisabled: false, canBeSmall: true, isCustomerManaged: true, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1086', { id: 1086, value: 'GoldStarFamilyMC', displayValue: 'Gold Star Family (Motorcycle)', description: 'Gold Star Family (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1087', { id: 1087, value: 'GovernmentMC', displayValue: 'Government (Motorcycle)', description: 'Government (Motorcycle)', canBePersonalized: false, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1089', { id: 1089, value: 'HistoricVehicleMC', displayValue: 'Historic Vehicle (Motorcycle)', description: 'Historic Vehicle (Motorcycle)', canBePersonalized: false, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1090', { id: 1090, value: 'MilitarySupportFreedomMC', displayValue: 'Military Support/Freedom (Motorcycle)', description: 'Military Support/Freedom (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1091', { id: 1091, value: 'PurpleHeartMedalMC', displayValue: 'Purple Heart Medal (Motorcycle)', description: 'Purple Heart Medal (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1093', { id: 1093, value: 'U.S.MarineMC', displayValue: 'U.S. Marine Corps (Motorcycle)', description: 'U.S. Marine Corps (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1094', { id: 1094, value: 'VeteranMC', displayValue: 'Veteran (Motorcycle)', description: 'Veteran (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1095', { id: 1095, value: 'FirstResponder', displayValue: 'First Responder', description: 'First Responder', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1096', { id: 1096, value: 'DealerTrailer', displayValue: 'Dealer Trailer', description: 'Dealer Trailer', canBePersonalized: false, canBeDisabled: false, canBeSmall: false, isCustomerManaged: true, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1097', { id: 1097, value: 'Route66MC', displayValue: 'Route 66 (Motorcycle)', description: 'Route 66 (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1098', { id: 1098, value: 'BarrettJackson', displayValue: 'Barrett-Jackson Auto Auction', description: 'Barrett-Jackson Auto Auction', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1099', { id: 1099, value: 'LukeAFB', displayValue: 'Luke Air Force Base', description: 'Luke Air Force Base', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1100', { id: 1100, value: 'LukeAFBMC', displayValue: 'Luke Air Force Base (Motorcycle)', description: 'Luke Air Force Base (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1101', { id: 1101, value: 'FirstResponderMC', displayValue: 'First Responder (Motorcycle)', description: 'First Responder (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1102', { id: 1102, value: 'ArizonaScienceCenter', displayValue: 'Arizona Science Center', description: 'Arizona Science Center', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1103', { id: 1103, value: 'CommunityService', displayValue: 'Community Service ', description: 'Community Service ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: true });
        this._dictionary.add('1104', { id: 1104, value: 'WomenVeteransArmy', displayValue: 'Women Veterans Army', description: 'Women Veterans Army', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1105', { id: 1105, value: 'WomenVeteransNavy', displayValue: 'Women Veterans Navy', description: 'Women Veterans Navy', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1106', { id: 1106, value: 'WomenVeteransMarine', displayValue: 'Women Veterans Marine', description: 'Women Veterans Marine', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1107', { id: 1107, value: 'WomenVeteransAirForce', displayValue: 'Women Veterans Air Force', description: 'Women Veterans Air Force', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1108', { id: 1108, value: 'WomenVeteransCoastGuard', displayValue: 'Women Veterans Coast Guard', description: 'Women Veterans Coast Guard', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1109', { id: 1109, value: 'WomenVeteransNativeAmerCodeTalk', displayValue: 'Women Veterans Native American Code Talker', description: 'Women Veterans Native American Code Talker', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: true });
        this._dictionary.add('1110', { id: 1110, value: 'DistinguishedFlyingCross', displayValue: 'Distinguished Flying Cross ', description: 'Distinguished Flying Cross ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1111', { id: 1111, value: 'ShareTheRoad', displayValue: 'Share the Road ', description: 'Share the Road ', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1112', { id: 1112, value: 'Habitat for Humanity', displayValue: 'Habitat for Humanity', description: 'Habitat for Humanity', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1113', { id: 1113, value: 'VeteranArmy', displayValue: 'Veteran Army', description: 'Veteran Army', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1114', { id: 1114, value: 'VeteranNavy', displayValue: 'Veteran Navy', description: 'Veteran Navy', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1115', { id: 1115, value: 'VeteranMarine', displayValue: 'Veteran Marine', description: 'Veteran Marine', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1116', { id: 1116, value: 'VeteranAirForce', displayValue: 'Veteran Air Force', description: 'Veteran Air Force', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1117', { id: 1117, value: 'VeteranCoastGuard', displayValue: 'Veteran Coast Guard', description: 'Veteran Coast Guard', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1118', { id: 1118, value: 'VeteranNativeAmerCodeTalk', displayValue: 'Veteran Code Talker', description: 'Veteran Code Talker', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1119', { id: 1119, value: 'HomeOwnership', displayValue: 'Habitat For Humanity', description: 'Habitat For Humanity', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: true });
        this._dictionary.add('1120', { id: 1120, value: 'Alzheimers Awareness', displayValue: 'Alzheimers Awareness', description: 'Alzheimers Awareness', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1121', { id: 1121, value: 'Fiesta Bowl', displayValue: 'Fiesta Bowl', description: 'Fiesta Bowl', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1122', { id: 1122, value: 'VeteranArmyMC', displayValue: 'Veteran Army (Motorcycle)', description: 'Veteran Army (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1123', { id: 1123, value: 'VeteranNavyMC', displayValue: 'Veteran Navy (Motorcycle)', description: 'Veteran Navy (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1124', { id: 1124, value: 'VeteranMarineMC', displayValue: 'Veteran Marine (Motorcycle)', description: 'Veteran Marine (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1125', { id: 1125, value: 'VeteranAirForceMC', displayValue: 'Veteran Air Force (Motorcycle)', description: 'Veteran Air Force (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1126', { id: 1126, value: 'VeteranCoastGuardMC', displayValue: 'Veteran Coast Guard (Motorcycle)', description: 'Veteran Coast Guard (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1127', { id: 1127, value: 'VeteranNativeAmerCodeTalkMC', displayValue: 'Veteran Code Talker (Motorcycle)', description: 'Veteran Code Talker (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1128', { id: 1128, value: 'WomenVeteransMC', displayValue: 'Women Veterans (Motorcycle)', description: 'Women Veterans (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: true });
        this._dictionary.add('1129', { id: 1129, value: 'WomenVeteransArmyMC', displayValue: 'Women Veterans Army (Motorcycle)', description: 'Women Veterans Army (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1130', { id: 1130, value: 'WomenVeteransNavyMC', displayValue: 'Women Veterans Navy (Motorcycle)', description: 'Women Veterans Navy (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1131', { id: 1131, value: 'WomenVeteransMarineMC', displayValue: 'Women Veterans Marine (Motorcycle)', description: 'Women Veterans Marine (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1132', { id: 1132, value: 'WomenVeteransAirForceMC', displayValue: 'Women Veterans Air Force (Motorcycle)', description: 'Women Veterans Air Force (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1133', { id: 1133, value: 'WomenVeteransCoastGuardMC', displayValue: 'Women Veterans Coast Guard (Motorcycle)', description: 'Women Veterans Coast Guard (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1134', { id: 1134, value: 'WomenVeteransNativeAmerCodeTalkMC', displayValue: 'Women Veterans Native American Code Talker (Motorcycle)', description: 'Women Veterans Native American Code Talker (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: true });
        this._dictionary.add('1135', { id: 1135, value: 'DistinguishedFlyingCrossMC', displayValue: 'Distinguished Flying Cross (Motorcycle)', description: 'Distinguished Flying Cross (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1137', { id: 1137, value: 'ArizonaRodeo', displayValue: 'Arizona Rodeo', description: 'Arizona Rodeo', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1138', { id: 1138, value: 'ArizonaRodeoMotorcycle', displayValue: 'Arizona Rodeo (Motorcycle)', description: 'Arizona Rodeo (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1139', { id: 1139, value: 'CongenitalHeartDefectAwareness', displayValue: 'Congenital Heart Defect Awareness', description: 'Congenital Heart Defect Awareness', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1140', { id: 1140, value: 'CongenitalHeartDefectAwarenessMotorcycle', displayValue: 'Congenital Heart Defect Awareness Motorcycle', description: 'Congenital Heart Defect Awareness Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1141', { id: 1141, value: 'VeteransofForeignWars', displayValue: 'Veterans of Foreign Wars', description: 'Veterans of Foreign Wars', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1142', { id: 1142, value: 'VeteransofForeignWarsMotorcycle', displayValue: 'Veterans of Foreign Wars (Motorcycle)', description: 'Veterans of Foreign Wars (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1143', { id: 1143, value: 'MakeAWishArizona', displayValue: 'Make A Wish Arizona', description: 'Make A Wish Arizona', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1144', { id: 1144, value: 'MakeAWishArizonaMotorcycle', displayValue: 'Make A Wish Arizona (Motorcycle)', description: 'Make A Wish Arizona (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1145', { id: 1145, value: 'VeteransofForeignWarsAuxiliary', displayValue: 'Veterans of Foreign Wars Auxiliary Arizona', description: 'Veterans of Foreign Wars Auxiliary Arizona', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1146', { id: 1146, value: 'VeteransofForeignWarsAuxiliaryMotorcycle', displayValue: 'Veterans of Foreign Wars Auxiliary Arizona (Motorcycle)', description: 'Veterans of Foreign Wars Auxiliary Arizona (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1147', { id: 1147, value: 'ChildrenAndFamilies', displayValue: 'Children and Families', description: 'Children and Families', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: true });
        this._dictionary.add('1148', { id: 1148, value: 'ChildrenAndFamiliesMotorcycle', displayValue: 'Children and Families Motorcycle', description: 'Children and Families Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: false, isSpecializedPlate: true });
        this._dictionary.add('1149', { id: 1149, value: 'Education&CommunityEnrichment', displayValue: 'Arizona Education', description: 'Arizona Education', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1150', { id: 1150, value: 'Education&CommunityEnrichmentMotorcycle', displayValue: 'Arizona Education (Motorcycle)', description: 'Arizona Education (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1151', { id: 1151, value: 'EmpoweringCharitableOrganizations', displayValue: 'EMPOWER', description: 'EMPOWER', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1152', { id: 1152, value: 'EmpoweringCharitableOrganizationsMotorcycle', displayValue: 'EMPOWER (Motorcycle)', description: 'EMPOWER (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1153', { id: 1153, value: 'EmpoweringTodaysYouth', displayValue: 'Alice Cooper\'s Solid Rock', description: 'Alice Cooper\'s Solid Rock', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1154', { id: 1154, value: 'EmpoweringTodaysYouthMotorcycle', displayValue: 'Alice Cooper\'s Solid Rock Motorcycle', description: 'Alice Cooper\'s Solid Rock Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1155', { id: 1155, value: 'RealEstateProfessional', displayValue: 'Arizona Realtors Homes for All', description: 'Arizona Realtors Homes for All', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1156', { id: 1156, value: 'RealEstateProfessionalMotorcycle', displayValue: 'Arizona Realtors Homes for All Motorcycle', description: 'Arizona Realtors Homes for All Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1157', { id: 1157, value: 'SupportCancerVictims', displayValue: 'Cancer Support for Families', description: 'Cancer Support for Families', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1158', { id: 1158, value: 'SupportCancerVictimsMotorcycle', displayValue: 'Cancer Support for Families Motorcycle', description: 'Cancer Support for Families Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1159', { id: 1159, value: 'Arizona4H', displayValue: 'Arizona 4H', description: 'Arizona 4H', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1160', { id: 1160, value: 'Arizona4HMotorcycle', displayValue: 'Arizona 4H (Motorcycle)', description: 'Arizona 4H (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1161', { id: 1161, value: 'ThunderbirdCharities', displayValue: 'Thunderbirds Charities', description: 'Thunderbirds Charities', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1162', { id: 1162, value: 'ThunderbirdCharitiesMotorcycle', displayValue: 'Thunderbirds Charities (Motorcycle)', description: 'Thunderbirds Charities (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1163', { id: 1163, value: 'Deaf/HardOfHearingMC', displayValue: 'Deaf / Hard of Hearing (Motorcycle)', description: 'Deaf / Hard of Hearing (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: false });
        this._dictionary.add('1164', { id: 1164, value: 'DineCollegeWarriors', displayValue: 'Din\u{00E9} College Warriors', description: 'Dine College Warriors', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1165', { id: 1165, value: 'DineCollegeWarriorsMotorcycle', displayValue: 'Din\u{00E9} College Warriors (Motorcycle)', description: 'Dine College Warriors Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1166', { id: 1166, value: 'USArmy', displayValue: 'U.S. Army', description: 'U.S. Army', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1167', { id: 1167, value: 'USArmyMotorcycle', displayValue: 'U.S. Army (Motorcycle)', description: 'U.S. Army Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1168', { id: 1168, value: 'ArizonaCoyotesMotorcycle', displayValue: 'Arizona Coyotes (Motorcycle)', description: 'Arizona Coyotes Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1169', { id: 1169, value: 'HonoringFallenPoliceOfficersMotorcycle', displayValue: 'Honoring Fallen Police Officers (Motorcycle)', description: 'Honoring Fallen Police Officers Motorcycle', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1170', { id: 1170, value: 'StateFortyEight', displayValue: 'State Forty Eight', description: 'State Forty Eight', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1171', { id: 1171, value: 'StateFortyEightMotorcycle', displayValue: 'State Forty Eight (Motorcycle)', description: 'State Forty Eight (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1172', { id: 1172, value: 'InLovingMemory', displayValue: 'In Loving Memory', description: 'In Loving Memory', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1173', { id: 1173, value: 'InLovingMemoryMotorcycle', displayValue: 'In Loving Memory (Motorcycle)', description: 'In Loving Memory (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1174', { id: 1174, value: 'KeepArizonaBeautifulMotorcycle', displayValue: 'Keep Arizona Beautiful (Motorcycle)', description: 'Keep Arizona Beautiful (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1175', { id: 1175, value: 'ArizonaDiamondbacksMotorcycle', displayValue: 'Arizona Diamondbacks (Motorcycle)', description: 'Arizona Diamondbacks (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1176', { id: 1176, value: 'NationalGuardMotorcycle', displayValue: 'National Guard (Motorcycle)', description: 'National Guard (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1177', { id: 1177, value: 'ArizonaHighwaysMotorcycle', displayValue: 'Arizona Highways (Motorcycle)', description: 'Arizona Highways (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1178', { id: 1178, value: 'HualapaiTribe', displayValue: 'Hualapai Tribe', description: 'Hualapai Tribe', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1179', { id: 1179, value: 'HualapaiTribeMotorcycle', displayValue: 'Hualapai Tribe (Motorcycle)', description: 'Hualapai Tribe (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1180', { id: 1180, value: 'RotaryInternational', displayValue: 'Rotary International', description: 'Rotary International', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1181', { id: 1181, value: 'RotaryInternationalMotorcycle', displayValue: 'Rotary International (Motorcycle)', description: 'Rotary International (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1182', { id: 1182, value: 'PhoenixRisingFC', displayValue: 'Phoenix Rising FC', description: 'Phoenix Rising FC', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1183', { id: 1183, value: 'PhoenixRisingFCMotorcycle', displayValue: 'Phoenix Rising FC (Motorcycle)', description: 'Phoenix Rising FC (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1184', { id: 1184, value: 'AutismSupport', displayValue: 'Autism Support', description: 'Autism Support', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1185', { id: 1185, value: 'AutismSupportMotorcycle', displayValue: 'Autism Support (Motorcycle)', description: 'Autism Support (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1186', { id: 1186, value: 'OvarianCancerAwareness', displayValue: 'Ovarian Cancer Awareness', description: 'Ovarian Cancer Awareness', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1187', { id: 1187, value: 'OvarianCancerAwarenessMotorcycle', displayValue: 'Ovarian Cancer Awareness (Motorcycle)', description: 'Ovarian Cancer Awareness (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1188', { id: 1188, value: 'VerdeValleyWineTrail', displayValue: 'Verde Valley Wine Trail', description: 'Verde Valley Wine Trail', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1189', { id: 1189, value: 'VerdeValleyWineTrailMotorcycle', displayValue: 'Verde Valley Wine Trail (Motorcycle)', description: 'Verde Valley Wine Trail (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1190', { id: 1190, value: 'PhoenixMercury', displayValue: 'Phoenix Mercury', description: 'Phoenix Mercury', canBePersonalized: true, canBeDisabled: true, canBeSmall: false, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
        this._dictionary.add('1191', { id: 1191, value: 'PhoenixMercuryMotorcycle', displayValue: 'Phoenix Mercury (Motorcycle)', description: 'Phoenix Mercury (Motorcycle)', canBePersonalized: true, canBeDisabled: true, canBeSmall: true, isCustomerManaged: false, sortOrder: 999999, active: true, isSpecializedPlate: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IPlateType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IPlateType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IPlateType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IPlateType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IPlateType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
